"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const index_1 = require("../index");
const context_1 = require("../../context");
const SearchResultContent = () => {
    const { tiles, isDesktop, isTabZeroResult, hasError } = (0, context_1.useSearchResultContext)();
    if ((isTabZeroResult && (tiles === null || tiles === void 0 ? void 0 : tiles.length) === 0) || hasError) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isDesktop ? (0, jsx_runtime_1.jsx)(index_1.FilterGroup, {}) : (0, jsx_runtime_1.jsx)(index_1.MobileFilterButton, {}), !isDesktop && (0, jsx_runtime_1.jsx)(index_1.SearchResultHitCount, {}), (0, jsx_runtime_1.jsx)(index_1.HitList, {}), !isDesktop && (0, jsx_runtime_1.jsx)(index_1.MobileFilterSideBar, {})] }));
};
exports.SearchResultContent = SearchResultContent;
